import { Navigate } from 'react-router-dom';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import {
  ANY_SPORT_MARKET_COMMON_PACKS,
  ANY_SPORT_MARKET_HOME,
} from '@sorare/core/src/constants/__generated__/routes';
import { useSimplifiedNav } from '@sorare/core/src/hooks/commonGame/useSimplifiedNav';
import { useIsMobileApp } from '@sorare/core/src/hooks/useIsMobileApp';
import { generateSportPath } from '@sorare/core/src/lib/routing/generateSportPath';

export const Market = () => {
  const { showSimplifiedNav } = useSimplifiedNav(Sport.FOOTBALL);
  const { isAndroidApp } = useIsMobileApp();
  if (showSimplifiedNav || isAndroidApp) {
    return (
      <Navigate
        to={generateSportPath(ANY_SPORT_MARKET_COMMON_PACKS, {
          sport: Sport.FOOTBALL,
        })}
        replace
      />
    );
  }

  return (
    <Navigate
      to={generateSportPath(ANY_SPORT_MARKET_HOME, { sport: Sport.FOOTBALL })}
      replace
    />
  );
};

export default Market;
